<template>
    <div class="custom-table-items">
        <div v-if="loading" class="loading-overlay">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Yükleniyor...</span>
            </div>
        </div>

        <table class="table">
            <thead class="thead-light">
                <tr>
                    <th>{{ $t('views.transactions.columns.date') }}</th>
                    <th>{{ $t('views.transactions.columns.type') }}</th>
                    <th>{{ $t('views.transactions.columns.orderId') }}</th>
                    <th>{{ $t('views.transactions.columns.description') }}</th>
                    <th>{{ $t('views.transactions.columns.amount') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="!loading && error">
                    <td colspan="6" class="text-center py-4 text-danger">
                        {{ error }}
                    </td>
                </tr>
                <tr v-else-if="!loading && detailItems.length === 0">
                    <td colspan="6" class="text-center py-4">
                        {{ $t('views.transactions.noData') }}
                    </td>
                </tr>
                <tr v-for="(item, index) in detailItems" :key="index">
                    <td>
                        <div v-html="formatDate(item.posted_date_time)"></div>
                    </td>
                    <td>
                        {{ item.transaction_type }}
                    </td>
                    <td>
                        {{ item.merchant_order_id }}
                    </td>
                    <td>{{ item.amount_type }} - {{ item.amount_description }}</td>
                    <td>
                        <div>
                            {{ item.currency || currencySymbol }} <strong class="text-secondary">{{ item.amount >= 0 ? '+' : '-' }}{{ formatNumber(Math.abs(item.amount)) }} </strong>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
// import DateRangePicker from '@/components/DateRangePicker.vue'
import { countryInfo } from '@/utils/helper'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    name: 'TransactionsDetail',
    components: {
        // DateRangePicker,
    },
    data() {
        return {
            searchTimeout: null,
            newSearchTimeout: null,
        }
    },
    computed: {
        ...mapState('transactions', {
            transactionDetailsState: (state) => state.transactionDetails || {},
        }),
        ...mapGetters('market', ['currentMarket']),
        detailItems() {
            return this.transactionDetailsState?.items || []
        },
        loading() {
            return this.transactionDetailsState?.loading || false
        },
        error() {
            return this.transactionDetailsState?.error || null
        },
        currencySymbol() {
            const countries = countryInfo()

            if (this.currentMarket && this.currentMarket.short) {
                return countries[this.currentMarket.short].symbol || countries[this.currentMarket.short].currency_text || 'USD'
            }

            return 'USD'
        },
    },
    created() {
        this.loadTransactionDetails()
    },
    beforeUnmount() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        if (this.newSearchTimeout) clearTimeout(this.newSearchTimeout)
    },
    methods: {
        ...mapActions('transactions', ['getTransactionDetails']),
        loadTransactionDetails() {
            const transactionId = this.$route.params.id
            if (transactionId) {
                this.getTransactionDetails(transactionId)
            }
        },
        formatNumber(number) {
            const numValue = parseFloat(number) || 0
            return numValue.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },
        formatDate(dateString) {
            if (!dateString) return ''

            const date = new Date(dateString)
            const day = date.getDate().toString().padStart(2, '0')
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const year = date.getFullYear()

            const formattedDate = `${day}.${month}.${year}`
            const formattedTime = date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', hour12: false })

            return `${formattedDate}, <br/> ${formattedTime}`
        },
    },
    watch: {
        '$route.params.id': {
            handler(newId) {
                if (newId) {
                    this.getTransactionDetails(newId)
                }
            },
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.custom-table-items {
    max-width: 100% !important;
    overflow: visible;
    min-height: 400px !important;
    position: relative;

    .spinner-border {
        width: 3rem;
        height: 3rem;
    }

    table {
        thead {
            top: 0;
            position: sticky;
            z-index: 10;
        }
    }

    tr {
        border-bottom: 1px solid #e7eaf3b2;
    }

    td {
        vertical-align: middle;
        height: 50px;
        padding-top: 8px;
        padding-bottom: 8px;
        color: #677788 !important;
        font-size: 0.8rem;
        font-weight: 400;

        strong {
            color: #00203f;
            font-weight: 600;
        }

        .status {
            color: #fff;
            font-size: 10.5px;
            font-weight: 700;
            line-height: 12.71px;
            padding: 3.67px 5.33px 3.67px 6.81px;
            border-radius: 5px;
            display: inline-flex;

            &.expense {
                background-color: #ed4c78;
            }
        }
    }
}

.thead-light {
    th {
        background-color: #f8fafd !important;
        border-bottom: 1px solid #e7eaf3b2 !important;
        color: #677788 !important;
        font-size: 11.9px !important;
        font-weight: 400 !important;
        line-height: 17.85px;
        font-weight: bold !important;
    }
}

.no-caret::after {
    display: none !important;
}

.dropdown-toggle::after {
    display: none !important;
}

.date-picker {
    width: 100%;
    font-size: 0.875rem;
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    border: 1px solid #e7eaf3;

    :deep(.dp__input) {
        padding: 0;
        font-size: 0.875rem;
        height: 31px;
    }
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}

.date-input {
    cursor: pointer;
    background-color: #fff;
}

.date-range-picker {
    position: absolute;
    z-index: 100;
}

.date-picker-wrapper {
    position: relative;
    width: 100%;
}

.date-picker-container {
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    z-index: 1050;
}

.datepicker-mount-point {
    min-width: 270px;
}

.currency-select {
    width: 80px !important;
    min-width: 80px !important;
    flex: 0 0 80px !important;
    padding-right: 0px !important;
}

.convert-icon {
    cursor: pointer;
    margin-left: 3px;
    opacity: 0.8;
    color: #ffb53e !important;
    &:hover {
        opacity: 1;
    }
}

.light-popper {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
}
</style>
